module.exports = __webpack_public_path__ + "media/images/shared/icon_food_white-ea0673d09ad5630bcfdb25380c85c5bf.png";